import { render, staticRenderFns } from "./draftModal.vue?vue&type=template&id=943d1482&scoped=true&"
import script from "./draftModal.vue?vue&type=script&lang=js&"
export * from "./draftModal.vue?vue&type=script&lang=js&"
import style0 from "./draftModal.vue?vue&type=style&index=0&id=943d1482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943d1482",
  null
  
)

export default component.exports